import { Injectable } from '@angular/core';
import { UserListService } from '@spartacus/organization/administration/components';
import { EntitiesModel } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class GonvarriUserListService extends UserListService {
  protected override convertUsers(
    users: EntitiesModel<any>
  ): EntitiesModel<any> {
    if (!users || !users.values) {
      return {
        values: [],
        pagination: users?.pagination || {},
        sorts: users?.sorts || [],
      };
    }
    const validValues = users.values.filter(user => user !== undefined);
    const validUserData = {
      ...users,
      values: validValues,
    };
    
    return super.convertUsers(validUserData);
  }
}